import { styled } from 'styled-components';
import { getAssetUrl } from '@common/utils/assetsUtils';

type DropzoneFileProps = {
    filename: string;
    mimeType: string;
    onFileRemove: () => void;
    onThumbnailClick: () => void;
    thumbnailUrl: string | undefined;
    uploadProgressPercentage?: number;
};

export function DropzoneFile(props: Readonly<DropzoneFileProps>) {
    const { filename, mimeType, thumbnailUrl, onFileRemove, onThumbnailClick, uploadProgressPercentage } = props;

    return (
        <File title={filename}>
            <div className="thumbnail">
                <div
                    className="thumbnail__link"
                    onClick={(event) => {
                        event.stopPropagation();
                        onThumbnailClick();
                    }}
                >
                    <img
                        alt="thumbnail"
                        className="thumbnail__img"
                        onError={(event) => ((event.target as HTMLImageElement).src = getAssetUrl(mimeType))}
                        src={thumbnailUrl ?? getAssetUrl(mimeType)}
                    />
                    {uploadProgressPercentage !== undefined && (
                        <UploadProgress progressPercentage={uploadProgressPercentage} />
                    )}
                </div>
                <button
                    className="btn btn-close thumbnail__close"
                    onClick={(event) => {
                        event.stopPropagation();
                        onFileRemove();
                    }}
                    type="button"
                />
            </div>
            <span>{filename}</span>
        </File>
    );
}

const File = styled.div`
    float: left;
    margin-right: 12px;
    overflow: hidden;
`;

type UploadProgressProps = Readonly<{
    progressPercentage: number;
}>;

function UploadProgress({ progressPercentage }: UploadProgressProps) {
    const size = 45;
    const strokeWidth = 5;
    const radius = size / 2 - strokeWidth;
    const circumference = 2 * radius * Math.PI;
    const dashOffset = (1 - progressPercentage / 100) * circumference;

    return (
        <StyledUploadProgress>
            <svg
                height={size}
                width={size}
            >
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    fill="transparent"
                    r={radius}
                    stroke="rgba(64, 55, 48, 0.2)"
                    strokeWidth={strokeWidth}
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    fill="transparent"
                    r={radius}
                    stroke="rgba(64, 55, 48, 0.8)"
                    strokeDasharray={`${circumference} ${circumference}`}
                    strokeDashoffset={dashOffset}
                    strokeWidth={strokeWidth}
                />
            </svg>
        </StyledUploadProgress>
    );
}

const StyledUploadProgress = styled.div`
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%) rotate(-90deg);
`;
